import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const modeloDatos = {
   clienteID: 0, 
    empresaID: 1,
    descripcion: "",
    rnc: "",
    direccion: "",
    telefono: "",
    correo:"",
      creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date(),
    fechaModificado: new Date(),
    ncfDefecto:1,
    nombreNCF:''
   
}

const Clientes = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [interativo, Setinterativo] = useState(false);
    const [SN, SetSN] = useState([]);
    const [Impresion, setImpresion] = useState(false);
    const [R_API, setR_API] = useState("")

    const handleChange = (e) => {
       // let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        let value =  e.target.value;
        if (e.target.name == "rnc" && e.target.value.length > 8) {

            if (Listado.filter(x => x.rnc == e.target.value).map(x => x.clienteID).length == 0) {
                ValidarRNC(e.target.value);
            }
            else {
                Swal.fire(
                    'Existe!',
                    '',
                    'danger'
                )
            }
          
        }
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const ValidarRNC = async (x) => {
        let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, descripcion: (data1).descripcion, rnc: x
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x
                })
            }
        }
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
            setR_API(Api + "VentasMantenimiento/listaClientes")
        }
    }

    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            SetSN(data.filter(x => x.esncf == 1).map(z => z))
        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerDatosSN()
    },[])


    const guardarCambios = async () => {

        let response;
        if (tabla.clienteID == 0) {
          
            response = await fetch(Api + "VentasMantenimiento/GuardarClientes", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasMantenimiento/EditarClientes", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
           
            setTabla(modeloDatos)
            setVerModal(!verModal);
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            obtenerDatos()
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "evaluaciondesempeno/EliminarPregunta/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.clienteID,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },     {
            name: 'RNC',
            selector: row => row.rnc,
            sortable: true,
        },   {
            name: 'Telefono',
            selector: row => row.telefono,
            sortable: true,
        },
       
       
        ,
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Lista de Clientes
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                    </a>
                </CardHeader>
                <CardBody>
                    <div class="box">
                        <div>  <Button color="success" size="sm"
                            onClick={() => setVerModal(!verModal)}
                        >Nuevo Cliente</Button> </div>
                        <div>  <button size="sm" color="primary" class="btn-search" block onClick={() => setImpresion(true)}>
                            <i class="fas fa-print"></i> Imprimir
                        </button></div>
                    </div>
                   

                  
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>  Mantenimiento de Cliente </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={3 } >
                    <FormGroup>
                    
                        <Label>RNC / Cedula</Label>
                                <Input bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                            </FormGroup></Col>
                        <Col md={6}>
                    <FormGroup>
                    
                        <Label>Nombre</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup></Col>

                        <Col md={3}>
                    <FormGroup>
                    
                        <Label>Telefono</Label>
                                <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                            </FormGroup></Col>
                        <Col md={3} >
                            <FormGroup>

                                <Label style={{ color: "red" }}>Tipo NCF</Label>
                                <Input className="form-control" bsSize="sm" type={"select"} name="ncfDefecto" onChange={handleChange} value={tabla.nCFDefecto} >
                                    {
                                        SN.map((item) => (<option key={item.secuenciaID} value={item.secuenciaID}>{item.descripcion}</option>))
                                    }

                                </Input>
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label>Correo</Label>
                                <Input bsSize="sm" name="correo" onChange={handleChange} value={tabla.correo} />
                            </FormGroup></Col>
                        <Col md={9}>
                    <FormGroup>
                    
                        <Label>Direccion</Label>
                                <Input bsSize="sm" name="direccion" onChange={handleChange} value={tabla.direccion} />
                        </FormGroup></Col>
                    
                       
                  </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                      onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        
            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {/*<a href="\imagen\Manual de usuario Sistema Evaluación de Desempeño ETED.pdf" target="_blank" >Descargar Manual PDF</a>*/}
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Clientes.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>


            <Modal className="modal-preguntas" isOpen={Impresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {<iframe
                                src={"/Informes/CXC/listaclientes.htm?API=" + R_API}
                                title="Contenido HTML"
                                style={{ width: '100%', height: '1100px', border: 'none' }}

                            />}


                            <Button size="sm" color="danger"
                                onClick={() => setImpresion(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

        </>
        )

}
export default Clientes;